<ng-container *hasPrivilege="'agreement/sign'; else signedAgreement">
  <ng-container
    *ngIf="
      hasUnsignedAgreement && (isImpersonating$ | async) === false;
      else signedAgreement
    "
  >
    <app-agreement (signed)="onAgreementSigned()"></app-agreement>
  </ng-container>
</ng-container>
<ng-template #signedAgreement>
  <ng-container *ngIf="allowIntoApp(); else subscribeNow">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
  <ng-template #subscribeNow>
    <div class="content">
      <app-subscribe></app-subscribe>
    </div>
  </ng-template>
</ng-template>
